module.exports = __webpack_public_path__ + "media/dancing-people.22f66a9e2547bf2d2be11df70dc38657.svg";